<p>log-cleanup-service works!</p>
